import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Apiservice from '../Apiservice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
const StaffAttendanceEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const userType = location.state?.userType;
    const attendanceId = location.state?.attendanceId;
    const fromPage = location.state?.fromPage;
    const filters = location.state?.filters;

    const [staffs, setStaffs] = useState([]);
    const [roles, setRoles] = useState([]);
    const [duties, setDuties] = useState([]);
    const [sites, setSites] = useState([]);

    const [staffName, setStaffName] = useState("");
    const [staffId, setStaffId] = useState(0);
    const [roleId, setRoleId] = useState(0);
    const [dutyId, setDutyId] = useState(0);
    const [siteId, setSiteId] = useState(0);
    const [siteIn, setSiteIn] = useState(null);
    const [siteOut, setSiteOut] = useState(null);
    const [latitude, setLatitude] = useState(0.0);
    const [longitude, setLongitude] = useState(0.0);

    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const data = { userType, attendanceId: attendanceId, status: 0 };
            let result = await Apiservice.AttendanceEditPage(data);

            if (result.success === true) {
                const att = result.data.attendance;

                setRoles(result.data.roles);
                setDuties(result.data.duties);
                setSites(result.data.sites);
                setStaffs(result.data.users);

                setStaffName(att.staffName);
                setStaffId(att.user_id);
                setRoleId(att.role_id);
                setDutyId(att.dutyTypeId);
                setSiteId(att.site_id);
                setSiteIn(att.entryTime ? new Date(att.entryTime.replace(' ', 'T')) : null);
                setSiteOut(att.exitTime ? new Date(att.exitTime.replace(' ', 'T')) : null);
                setLatitude(att.entryLatitude);
                setLongitude(att.entryLongitude);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: result.message
                });
                navigate('/attendance')
            }
        };
        fetchData();
    }, [userType, attendanceId]);

    const parseDateTimeForStorage = (date) => {
        if (!date || !(date instanceof Date)) return null;

        const utcYear = date.getUTCFullYear();
        const utcMonth = String(date.getUTCMonth() + 1).padStart(2, "0");
        const utcDay = String(date.getUTCDate()).padStart(2, "0");
        const utcHours = String(date.getUTCHours()).padStart(2, "0");
        const utcMinutes = String(date.getUTCMinutes()).padStart(2, "0");
        const utcSeconds = String(date.getUTCSeconds()).padStart(2, "0");

        return `${utcYear}-${utcMonth}-${utcDay} ${utcHours}:${utcMinutes}:${utcSeconds}`;
    };


    const siteChange = (selectedSiteId) => {
        setSiteId(selectedSiteId);
        const site = sites.find((site) => site.id === parseInt(selectedSiteId));
        if (site) {
            setLatitude(site.latitude);
            setLongitude(site.longitude);
        }
    };

    const validate = () => {
        let tempErrors = {};
        if (userType === "normal") {
            if (!staffId || staffId === "0") {
                tempErrors.staffId = "Please select a staff member.";
            }
        }

        if (userType === "floater") {
            if (!staffName || staffName.trim() === "") {
                tempErrors.staffName = "Please enter staff name.";
            }
        }
        if (!roleId || roleId === "0") tempErrors.roleId = "Please select a role.";
        if (!siteId || siteId === "0") tempErrors.siteId = "Please select a site.";
        if (!siteIn) tempErrors.siteIn = "Please select Site In datetime.";
        // if (!siteOut) tempErrors.siteOut = "Please select Site Out datetime.";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validate()) return;
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update this attendance?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Update",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
        });

        if (!confirm.isConfirmed) return;


        let result = null;   // ✅ declare outside

        if (userType === "normal") {

            const data = {
                attendanceId: attendanceId,
                site_id: siteId,
                user_id: staffId,
                role_id: roleId,
                dutyTypeId: dutyId,
                entryTime: parseDateTimeForStorage(siteIn),
                exitTime: siteOut ? parseDateTimeForStorage(siteOut) : null,
            };

            result = await Apiservice.UpdateAttendance(data);

        } else if (userType === "floater") {

            const data = {
                floaterAttendanceId: attendanceId,
                staffName: staffName,
                site_id: siteId,
                role_id: roleId,
                dutyTypeId: dutyId,
                entryTime: parseDateTimeForStorage(siteIn),
                exitTime: siteOut ? parseDateTimeForStorage(siteOut) : null,
            };

            result = await Apiservice.FloaterAttendanceUpdate(data);
        }

        // ✅ common response handling
        if (result?.success === true) {
            alert("Updated Successfully");
            navigate(fromPage, {
                state: {
                    refresh: true,
                    editedId: attendanceId,
                    filters
                }
            });
        } else {
            alert(result?.message || "Something went wrong");
        }
    };


    return (
        <div className="container mt-4">
            <div className="card shadow p-4">
                <h4 className="mb-4 text-primary">Edit Staff Attendance</h4>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Staff Name</label>
                    <div className="col-sm-6">
                        {
                            userType === "normal" ? (
                                <select
                                    className="form-select form-select-sm"
                                    value={staffId}
                                    onChange={(e) => setStaffId(e.target.value)}
                                >
                                    <option value="0">-- Select Staff --</option>
                                    {staffs.map((staff) => (
                                        <option key={staff.id} value={staff.id}>
                                            {staff.firstName} {staff.lastName}
                                        </option>
                                    ))}
                                </select>
                            ) : userType === "floater" ? (
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={staffName}
                                    onChange={(e) => setStaffName(e.target.value)}
                                />
                            ) : null
                        }

                        {userType === "normal" && errors.staffId && (
                            <div className="text-danger small">{errors.staffId}</div>
                        )}

                        {userType === "floater" && errors.staffName && (
                            <div className="text-danger small">{errors.staffName}</div>
                        )}
                    </div>
                </div>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Role</label>
                    <div className="col-sm-6">
                        <select className="form-select form-select-sm" value={roleId} onChange={(e) => setRoleId(e.target.value)}>
                            <option value="0">-- Select Role --</option>
                            {roles.filter(role => role.name !== "Super Admin").map((role) => (
                                <option key={role.id} value={role.id}>{role.name}</option>
                            ))}
                        </select>
                        {errors.roleId && <div className="text-danger small">{errors.roleId}</div>}
                    </div>
                </div>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Duty Type</label>
                    <div className="col-sm-6">
                        <select className="form-select form-select-sm" value={dutyId} onChange={(e) => setDutyId(e.target.value)}>
                            <option value="0">-- Select Duty Type --</option>
                            {duties.map((duty) => (
                                <option key={duty.id} value={duty.id}>{duty.duty}</option>
                            ))}
                        </select>
                        {errors.dutyId && <div className="text-danger small">{errors.dutyId}</div>}
                    </div>
                </div>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Site</label>
                    <div className="col-sm-6">
                        <select className="form-select form-select-sm" value={siteId} onChange={(e) => siteChange(e.target.value)}>
                            <option value="0">-- Select Site --</option>
                            {sites.map((site) => (
                                <option key={site.id} value={site.id}>{site.name}</option>
                            ))}
                        </select>
                        {errors.siteId && <div className="text-danger small">{errors.siteId}</div>}
                    </div>
                </div>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Site In</label>
                    <div className="col-sm-6">
                        <DatePicker
                            selected={siteIn}
                            onChange={(date) => setSiteIn(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy HH:mm:ss"
                            placeholderText="Select In Time"
                            className={`form-control form-control-sm ${errors.siteIn ? 'is-invalid' : ''}`}
                            isClearable
                        />
                        {errors.siteIn && <div className="invalid-feedback d-block">{errors.siteIn}</div>}
                    </div>
                </div>

                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Site Out</label>
                    <div className="col-sm-6">
                        <DatePicker
                            selected={siteOut}
                            onChange={(date) => setSiteOut(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy HH:mm:ss"
                            placeholderText="Select Out Time"
                            className={`form-control form-control-sm ${errors.siteOut ? 'is-invalid' : ''}`}
                            isClearable
                        />
                        {errors.siteOut && <div className="invalid-feedback d-block">{errors.siteOut}</div>}
                    </div>
                </div>

                <div className="mt-4 text-center">
                    <button className="btn btn-primary btn-sm px-4" onClick={handleSave}>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StaffAttendanceEdit;
